import {
  Button,
  Classes,
  ControlGroup,
  Dialog,
  FormGroup,
  H1,
  HTMLSelect,
  HTMLTable,
  Icon,
  InputGroup,
  IOptionProps,
} from "@blueprintjs/core";
import { Businesses } from "@just-in-types";
import * as React from "react";
import { connect } from "react-redux";
import { firestore } from "../firebase";
import { IState } from "../store";
import { GetBusinessesSnapshot, getBusinessesSnapshot } from "../store/actions";

interface Option extends IOptionProps {
  value: string;
}

interface IBusinessesDispatchProps {
  onGetBusinessesSnapshot: GetBusinessesSnapshot;
}

interface IBusinessesStateProps {
  businesses: Businesses.Business[];
}

type Props = IBusinessesDispatchProps & IBusinessesStateProps;

interface WheelOptionsState {
  businessId: null | string;
  businessOptions: Option[];
  businessWheels: any[];
  formFields: any;
  isOpen: boolean;
  loading: boolean;
  options: any[];
  wheelId: string;
}

class WheelOptions extends React.Component<Props, WheelOptionsState> {
  public options = [
    { label: "", guid: "" },
    { label: "", guid: "" },
    { label: "", guid: "" },
    { label: "", guid: "" },
    { label: "", guid: "" },
  ];
  public state: WheelOptionsState = {
    businessId: "",
    businessOptions: [],
    businessWheels: [],
    formFields: {},
    isOpen: false,
    loading: true,
    options: this.options,
    wheelId: "",
  };

  public componentDidMount() {
    this.buildOptions();
  }

  public componentDidUpdate({ businesses: prevBusinesses }: Props) {
    const { businesses } = this.props;

    if (prevBusinesses.length !== businesses.length) {
      this.buildOptions();
    }
  }

  public render() {
    const {
      businessId,
      businessOptions,
      businessWheels,
      formFields,
      isOpen,
      loading,
      options,
    } = this.state;
    const dialogProps: Dialog["props"] = {
      canEscapeKeyClose: true,
      canOutsideClickClose: true,
      isOpen,
      onClose: this.toggleModal,
      title: "Wheel Data",
    };
    if (loading) {
      return (
        <div>
          <br />
          <br />
          <br />
          <H1>
            Loading...{" "}
            <Icon className="icon-spin" icon="refresh" iconSize={40} />
          </H1>
        </div>
      );
    }
    return (
      <div>
        <H1 style={{ margin: "10px auto" }}>Wheel Options!</H1>
        <div>
          <HTMLSelect
            onChange={this.handleBusiness}
            options={businessOptions}
            value={businessId || ""}
          />
        </div>

        <Button
          intent="primary"
          style={{ marginTop: "0.5rem" }}
          onClick={this.addWheel}
        >
          Add Wheel
        </Button>

        {businessWheels.length > 0 ? (
          <div style={{ marginTop: "0.5rem" }}>
            <HTMLTable bordered={true} striped={true} style={{ width: "100%" }}>
              <thead>
                <tr style={{ borderTop: "0.5px solid black" }}>
                  <th>Wheel Id</th>
                  <th>Name</th>
                  <th>Option - Guid</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {businessWheels.map((wheel, index) => (
                  <tr key={index}>
                    <td>{wheel.id}</td>
                    <td>{wheel.wheelName}</td>
                    <td>
                      {wheel.options.map((option: any) => (
                        <>
                          {option.label} - {option.guid} <br />
                        </>
                      ))}
                    </td>
                    <td>{wheel.status}</td>
                    <td>
                      <Button
                        intent="success"
                        onClick={() => this.editWheel(index)}
                      >
                        Edit
                      </Button>
                      &nbsp;
                      <Button 
                        intent="primary" 
                        onClick={() => this.copyWheel(index)}
                      >
                        Copy
                      </Button>
                      &nbsp;
                      <Button
                        intent="danger"
                        onClick={() => this.deleteWheel(index)}
                      >
                        Delete
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </HTMLTable>
          </div>
        ) : (
          ""
        )}
        <Dialog {...dialogProps}>
          <div className={Classes.DIALOG_BODY}>
            <form onSubmit={this.handleSubmit}>
              <ControlGroup fill={true}>
                <FormGroup label={"Wheel Name"} labelFor="text-wheel-name">
                  <InputGroup
                    id="text-wheel-name"
                    type="text"
                    name="wheelName"
                    defaultValue={formFields.wheelName}
                    placeholder="Wheel Name"
                    required={true}
                  />
                </FormGroup>
              </ControlGroup>

              {options.map((option, idx) => (
                <ControlGroup fill={true} vertical={false}>
                  <FormGroup label={`Wheel Option ${idx + 1}`}>
                    <InputGroup
                      type="text"
                      defaultValue={option.label}
                      placeholder={`Wheel Option ${idx + 1}`}
                      onChange={this.handleOptionChange(idx, "label")}
                    />
                  </FormGroup>
                  <FormGroup label={`Wheel Option Guid ${idx + 1}`}>
                    <InputGroup
                      type="text"
                      defaultValue={option.guid}
                      placeholder={`Wheel Option ${idx + 1}`}
                      onChange={this.handleOptionChange(idx, "guid")}
                    />
                  </FormGroup>
                </ControlGroup>
              ))}

              <ControlGroup fill={true}>
                <FormGroup label={"Status"} labelFor="text-status">
                  <HTMLSelect
                    id="text-status"
                    name="status"
                    defaultValue={formFields.status}
                    options={["enable", "disable"]}
                  />
                </FormGroup>
              </ControlGroup>

              <Button type="submit" intent="primary">
                Submit
              </Button>
            </form>
          </div>
        </Dialog>
      </div>
    );
  }

  private toggleModal = () =>
    this.setState(({ isOpen }) => ({ isOpen: !isOpen }));

  private handleOptionChange = (idx: number, ipt: string) => (evt: any) => {
    const newOptions = this.state.options.map((option, sidx) => {
      if (idx !== sidx) {
        return option;
      }
      if (ipt === "label") {
        return { ...option, label: evt.target.value };
      } else {
        return { ...option, guid: evt.target.value };
      }
    });

    this.setState({ options: newOptions });
  };

  private addWheel = () => {
    const { businessId } = this.state;
    if (businessId) {
      const formFields = {
        status: "enable",
        wheelName: "",
      };

      const options = this.options;

      this.setState({ formFields, isOpen: true, options, wheelId: "" });
    }
  };

  private editWheel = (index: number) => {
    const { businessWheels } = this.state;
    const currentWheel = businessWheels[index];

    const formFields = {
      status: currentWheel.status,
      wheelName: currentWheel.wheelName,
    };
    const options = currentWheel.options;
    this.setState({
      formFields,
      isOpen: true,
      options,
      wheelId: currentWheel.id,
    });
  };

  private deleteWheel = async (index: number) => {
    if (
      confirm("Are you sure you want to delete this thing into the database?")
    ) {
      const { businessId, businessWheels } = this.state;
      const wheelId = businessWheels[index].id;
      if (businessId && wheelId) {
        await firestore
          .collection("wheels")
          .doc(wheelId)
          .delete();
        console.log(wheelId);
        this.loadWheels(businessId);
      }
    }
  };

  private copyWheel = async(index: number) => {
    const { businessWheels } = this.state;
    const wheelId = businessWheels[index].id;
    if(wheelId) {
      const wheelUrl = `https://just-in.texnrewards.com/wheel?wheel_id=${wheelId}&mobile=~mobile~`;
      console.log(wheelUrl);

      const tempInput = document.createElement("input");
      tempInput.value = wheelUrl;
      document.body.appendChild(tempInput);
      tempInput.select();
      document.execCommand("copy");
      document.body.removeChild(tempInput);

      alert("successfully copied");
    }
  }

  private handleBusiness = async ({
    currentTarget: { value },
  }: React.ChangeEvent<HTMLSelectElement>) => {
    const businessId = value;
    this.setState({ businessId });

    this.loadWheels(businessId);
  };

  private loadWheels = async (businessId: string) => {
    const businessWheels: any = [];
    if (businessId) {
      const wheels = await firestore
        .collection("wheels")
        .where("businessId", "==", businessId)
        .get();
      if (wheels.size > 0) {
        wheels.forEach((doc) => {
          const wheel = doc.data();
          const id: string = doc.id;
          businessWheels.push({ id, ...wheel });
        });
      }
    }
    this.setState({ businessWheels });
  };

  private handleSubmit = async (event) => {
    event.preventDefault();
    const { businessId, options, wheelId } = this.state;

    console.log(options);

    const wheelName = event.target.wheelName.value;
    const status = event.target.status.value;

    // const options: string[] = [];
    // event.target.querySelectorAll('[name="options"]').forEach((e) => {
    //   if(e.value) {
    //     options.push(e.value);
    //   }
    // });

    if (businessId && wheelName && options.length > 0) {
      const mainOptions = options.filter(
        (item) => item.label !== "" && item.guid !== ""
      );
      if (wheelId) {
        await firestore
          .collection(`wheels`)
          .doc(wheelId)
          .update({ options: mainOptions, status, wheelName });
      } else {
        await firestore.collection(`wheels`).add({
          businessId,
          createdAt: new Date().valueOf(),
          options: mainOptions,
          status,
          wheelName,
        });
      }
      this.setState({ isOpen: false });

      this.loadWheels(businessId);
    }
  };

  private buildOptions() {
    const { businesses } = this.props;
    const businessOptions: Option[] = [];
    businesses.forEach(({ businessId, businessName }) => {
      businessOptions.push({ label: businessName, value: businessId });
    });

    if (businessOptions.length) {
      businessOptions.unshift({ label: "select business", value: "" });
      this.setState({ businessOptions, loading: false });
    }
  }
}

const mapStateToProps = ({ businesses: { businesses } }: IState) => ({
  businesses,
});

const mapDispatchToProps = {
  onGetBusinessesSnapshot: getBusinessesSnapshot,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WheelOptions);



// WEBPACK FOOTER //
// ./src/views/WheelOptions.tsx